import store from '@/store/'
export default [
  {
    path: '/export',
    name: 'export',
    component: () =>
      import(
        /* webpackChunkName: 'export' */ '@/modules/export/_views/Index'
      ),
    async beforeEnter (to, from, next) {
      await store.dispatch('ExportStore/fetchExportationFlows', false).then(async () => {
        let exportationFlows = store.getters['ExportStore/exportationFlows']
        if (exportationFlows.length > 0) {
          await store.dispatch('ExportStore/fetchExportationFlow', exportationFlows[0].id)
        }
        next()
      }).catch(() => next())
    },
    children: [
      {
        name: 'export_create',
        path: 'create',
        meta: {
          section: 'export',
          allowedRoles: []
        },
        component: () =>
          import(
            /* webpackChunkName: 'create-export' */ '@/modules/export/_views/create/CreateExportIndex'
          )
      },
      {
        name: 'export_table_all',
        path: 'all',
        meta: {
          section: 'export',
          allowedRoles: []
        },
        component: () =>
          import(
            /* webpackChunkName: 'list-export' */ '@/modules/export/_views/list/ListExportIndex'
          )
      },
      {
        name: 'export_table_transactions',
        path: 'transactions',
        meta: {
          section: 'export',
          allowedRoles: []
        },
        component: () =>
          import(
            /* webpackChunkName: 'list-export' */ '@/modules/export/_views/list/ListExportIndex'
          )
      },
      {
        name: 'export_table_expenses',
        path: 'expenses',
        meta: {
          section: 'export',
          allowedRoles: []
        },
        component: () =>
          import(
            /* webpackChunkName: 'list-export' */ '@/modules/export/_views/list/ListExportIndex'
          )
      },
      {
        name: 'export_exported',
        path: 'exported',
        meta: {
          section: 'export',
          allowedRoles: []
        },
        component: () =>
          import(
            /* webpackChunkName: 'list-export' */ '@/modules/export/_views/exported/ExportedIndex'
          )
      }
    ]
  }
]
